import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import { useApiError } from '../useApiError';
export const useBenefitCode = (orderId: string, payMethod: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  const { set: setError } = useApiError();
  // console.log("usePaymethodcontext---------", context.useApiError);

  // Shared ref holding the response from the API
  const result = sharedRef(null, `useBenefitCode-${orderId}-${payMethod}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useBenefitCode-loading-${orderId}-${payMethod}`);

  // Shared ref holding errors from the methods
  const error = sharedRef(null, `useBenefitCode-error-${orderId}-${payMethod}`);

  // 使用折扣码
  const add = async (customQuery) => {
    try {
      loading.value = true;
      let res = null;
      // console.log('折扣码参数---------', customQuery);
      // 判断customQuery.promotion_code是数组还是字符串
      if (customQuery.promotion_code instanceof Array) {
        res = await context.$xbuy.api.BenefitCodeOperates(customQuery);
      } else {
        res = await context.$xbuy.api.benefitCode(customQuery);
      }
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        result.value = res?.data?.data;
        error.value = null;
      } else {
        setError({ message: res.message, code: res.code });
        result.value = null;
        error.value = res.message;
      }
    } catch (err) {
      error.value = err.message;
    } finally {
      loading.value = false;
    }
  };

  return {
    addCode: add,
    result: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
